import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'

export default {
  revenue: [
    {
      name: 'Total Revenue',
      key: 'totalRevenue',
      link: 'total-revenue'
    },
    {
      name: 'Net Revenue',
      key: 'netRevenue',
      link: 'net-revenue'
    },
    {
      name: 'Revenue By Customer',
      key: 'revenueByCustomer',
      link: 'revenue-by-customer'
    },
    {
      name: 'Revenue By Outlet',
      key: 'revenueByOutlet',
      link: 'revenue-by-outlet'
    },
    {
      name: 'Revenue By Seller',
      key: 'seller',
      link: 'seller'
    },
    {
      name: 'Revenue By Cashier',
      key: 'cashier',
      link: 'cashier'
    },
    {
      name: 'Revenue By Category',
      key: 'revenueByCategory',
      link: 'revenue-by-category'
    },
    {
      name: 'Sale Report',
      key: 'salesReport',
      link: 'sales-report'
    },
    {
      name: 'Payment Methods',
      key: 'payment',
      link: 'payment'
    }
  ],
  orders: [
    {
      name: 'Total Number Of Orders',
      key: 'numberOfOrders',
      link: 'number-of-orders'
    },
    {
      name: 'Average Order Value',
      key: 'averageOrderValue',
      link: 'average-order-value'
    },
    {
      name: 'Average Items Per Order',
      key: 'averageItemPerOrder',
      link: 'average-item-per-order'
    },
    {
      name: 'Sales Order',
      key: 'salesOrder',
      link: 'sales-order'
    },
    {
      name: 'Refund',
      key: 'refund',
      link: 'refund'
    },
    {
      name: 'Discount',
      key: 'discount',
      link: 'discount'
    },
    {
      name: 'Fulfillment',
      key: 'fulfillment',
      link: 'fulfillment'
    },
    {
      name: 'Payment Status',
      key: 'paymentStatus',
      link: 'payment-status'
    },
    ...(getItemByLocalStorage(localStorageKey.CURRENT_PLATFORM) === 'msi'
      ? [
        {
          name: 'Order Status',
          key: 'orderStatus',
          link: 'order-status'
        }
      ]
      : []),
    {
      name: 'Average duration',
      key: 'averageDuration',
      link: 'average-duration'
    },
    {
      name: 'Time In Status',
      key: 'timeInStatus',
      link: 'time-in-status'
    },
    {
      name: 'Tippings',
      key: 'tippings',
      link: 'tippings'
    }
  ],
  products: [
    {
      name: 'Quantity sold',
      key: 'productSold',
      link: 'product-sold'
    },
    {
      name: 'Revenue by product',
      key: 'revenueByProduct',
      link: 'revenue-by-product'
    }
  ],
  globalOptions: [
    {
      name: 'Outlets',
      key: 'global',
      link: 'global'
    },
    {
      name: 'Countries',
      key: 'global-stores',
      link: 'global-stores'
    }
  ],
  tax: [
    {
      name: 'Tax',
      key: 'tax',
      link: 'tax'
    }
  ]
}
